export const sharepointServices = {
  SHAREPOINT: {
    GET_TOKEN: '/sharepoint/getToken',
    UPLOAD: '/sharepoint/upload',
    DONWLOAD: '/sharepoint/download'
  }
};
